export default "__VITE_ASSET__d9a178ec__"